export enum DrawerEvent {
  OPEN_DRAWER = "openDrawer_quote",
  EXIT = "exitDrawer_quote",
}

export enum MonthPlannerEventEnum {
  CHANGE = "change",
}
